import { getTranslate } from 'react-localize-redux';
import store from '../state/store';

const useTranslation = () => getTranslate(store.getState().localize);

export default useTranslation;
